import React from 'react';
import PropTypes from 'prop-types';

const CCustoBadge = (props) => {
    return (
        <span className="badge badge-dark" style={{ margin: "0 2px" }}><i className={`fas fa-${props.codigo_icone}`} alt={props.nome} /></span>
    );
};

CCustoBadge.propTypes = {
    codigo_icone: PropTypes.string,
    nome: PropTypes.string.isRequired
};

export default CCustoBadge;


// WEBPACK FOOTER //
// ./src/components/ccustos/CCustoBadge.js